import React from "react";
import { createContext } from "react";
import { useState } from "react";
// import Home from './Home';
// import Hollywood from './Hollywood';
// import Bollywood from './Bollywood';

export const Store = createContext();
const Details = (props) => {
  const [details, setDetails] = useState([
    {
      id: 1,
      title: "khakee the bihar chapter",
      img: "https://m.media-amazon.com/images/M/MV5BZjUyZjNmMTMtMTZmMS00N2FjLWJlZGUtMWM5OWE2MjdlOGU0XkEyXkFqcGdeQXVyOTI3MzI4MzA@._V1_.jpg",
      category: "Hollywood",
      description:
        " ठोक देंगे कट्टा कपार में, आइए ना हमरा बिहार में :-Khakee series is a story of a police officer and his team trying to remove crime from a village in Bihar and what all obstacles do they face in the joureny? Do they get hold of the criminals there? That is what you get to see in the story. Nice acting by the cast. I mean all the actors have performed exceptionally well. I was really impressed with the acting of Ashustosh Rana in this series. He was impressive in his acting performance as well as entertaining. Karan Tacker as lead actor of the series was also okay. Avinashi Tiwari villain, his acting we didnt like inititally but towards the between and end of the sereis, we slowly developed a liking for him, his acting, his voice and his personality",
    },


    {
      id: 2,
      title: "Hacked Movie",
      img: "https://static-koimoi.akamaized.net/wp-content/new-galleries/2020/02/hacked-movie-review-hina-khan-makes-a-promising-debut-in-this-desi-dramatic-mashup-of-you-black-mirror-1.jpg",
      category: "Hollywood",
      description:
        "Hacked (2020) is but a cancerous movie reeking of extremely toxic pseudo-feminism At the outset, please be so gracious as to elucidate upon the genre of this film Is it science fiction? Is it women empowerment? Does it pertain to social issues? Or is it but a haphazard amalgamation of all of them? ",
    },
    {
      id: 3,
      title: "Miss India",
      img: "https://upload.wikimedia.org/wikipedia/en/5/53/Miss_India_poster.jpg",
      category: "Hollywood",
      description:
        "The film has been produced by Mahesh S. Koneru under East Coast Productions. Dani Sanchez-Lopez and Sujith Vaassudev handled the cinematography, while S. Thaman composed the music.[3] The film was planned to be released on 17 April 2020 but has been postponed due to the COVID-19 pandemic. The film is released on Netflix on 4 November 2020 in Telugu along with dubbed versions in Tamil and Malayalam.[4][5]",
    },
    {
      id: 4,
      title: "Corporate Movie",
      img: "https://upload.wikimedia.org/wikipedia/en/6/67/Corporate%28Film%29.jpg",
      category: "Hollywood",
      description:
        "Corporate centers around the power games between two industrialists, The Sehgal Group of Industries (SGI) owned by Vinay Sehgal and the Marwah Group of Industries (MGI) owned by Dharmesh Marwah. The two companies are traditional rivals in the food and beverages products business. Nishigandha Nishi  Dasgupta is the vice-president of SGI, while Vinay Sehgal's brother-in-law Ritesh joins in later as senior vice president",
    },
    {
      id: 5,
      title: " 3 Idiots ",
      img: "https://i.ytimg.com/vi/AqeagE1c1nE/maxresdefault.jpg",
      category: "Hollywood",
      description:
        "In college, Farhan and Raju form a great bond with Rancho due to his positive and refreshing outlook to life. Years later, a bet gives them a chance to look for their long-lost friend whose existence seems rather elusive.",
    },
    {
      id: 6,
      title: " 3 Idiots ",
      img: "https://i.ytimg.com/vi/AqeagE1c1nE/maxresdefault.jpg",
      category: "Hollywood",
      description:
        "In college, Farhan and Raju form a great bond with Rancho due to his positive and refreshing outlook to life. Years later, a bet gives them a chance to look for their long-lost friend whose existence seems rather elusive.",
    },
    {
      id: 7,
      title: "BLACKPINK’s ",
      img: "https://static-koimoi.akamaized.net/wp-content/new-galleries/2023/08/blackpinks-jennie-gets-brutally-trolled-by-another-bandmate-lisas-thai-fans-for-this-reason-formers-fans-come-in-support-of-her-say-jennie-doesnt-deserve-the-hate.jpg",
      category: "Bollywood",
      description:
        "As the day of expiration comes closer for the band BLACKPINK’s contract with YG Entertainment, every now and then, the band members are leading the headlines for something or the other. While Jisoo has broken the internet with her confirmed relationship with Ahn Bo Hyun, Jennie and Lisa got caught in a controversy",
    },
    {
      id: 8,
      title: "Munna Bhai M.B.B.S",
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6VMoGDi-H8Un7Ahbt6PdZjn5GpMJsHPmqHa8UdxgE8uJp3imf36swj9OinQ&s",
      category: "Bollywood",
      description:
        "Munna Bhai M.B.B.S. Is A National Award Winning Bollywood Comedy Hindi Movie, Directed By Rajkumar Hirani, Starring Sanjay Dutt And Arshad Warsi In The Lead Roles. The Film Won 18 Awards. Munna Is A Goon Who Sets Out To Fulfill His Father's Dream Of Becoming A Doctor. With Help From His Sidekick Circuit, He Enrolls Himself In Medical College And Drives Dr Asthana Up The Wall.",
    },
    {
      id: 9,
      title: "Farzi",
      img: "https://karnatakastateopenuniversity.in/wp-content/uploads/2023/03/Farzi-Movie-Download.jpg",
      category: "Bollywood",
      description:
        "Recently, Shahid Kapoor appear in the web series Farzi Movie. Fans of Shahid Kapoor have waited a long time for his next movie, but they no longer have to. In January, the fake film direct by Shahid Kapoor’s trailer was made public. His crazed appearance was the reason why his fans wait so long for his fictitious web series.",
    },
    {
      id: 10,
      title: "Pk",
      img: "https://m.media-amazon.com/images/M/MV5BMTYzOTE2NjkxN15BMl5BanBnXkFtZTgwMDgzMTg0MzE@._V1_QL75_UY266_CR2,0,180,266_.jpg",
      category: "Bollywood",
      description:
        "P.K.: Which god should I believe? You all say that, it's only one god. I say, no... there are two gods. One is the one who created us all. The other one is the one created by people like you. We know nothing about the god who made us all. But the god people like you made is exactly like you... liar, pretend to act, giving false promises, meeting rich people sooner, letting the poor neglected, happy when get praised... People are afraid to even say a word. My right number is very simple, the God who created us all, put faith in Him. And the god like you created, the duplicate god, destroy it.",
    },
    {
      id: 11,
      title: "MS Dhoni",
      img: "https://m.media-amazon.com/images/M/MV5BZjAzZjZiMmQtMDZmOC00NjVmLTkyNTItOGI2Mzg4NTBhZTA1XkEyXkFqcGdeQXVyODE5NzE3OTE@._V1_QL75_UY266_CR2,0,180,266_.jpg",
      category: "Bollywood",
      description:
        "Mahendra Singh Dhoni is a goalkeeper in school football team. Bannerjee a school cricket coach asks him to join his cricket team and practice daily with him for two hours time passes and he becomes a big state-level cricketer, but for a long time luck doesn't favor him to become a member of the Indian Cricket team. Dhoni takes a job in Indian Railways as a ticket-checker and plays cricket for the railways; after four years he gets selected for the Indian Cricket team and turns out to be one of the best cricketing captains in the history of Indian Cricket.",
    },
    {
      id: 12,
      title: "The Money Heist",
      img: "https://resizing.flixster.com/ITt1FPrFePNR6FSqZrZK7BocG2U=/ems.cHJkLWVtcy1hc3NldHMvdHZzZWFzb24vUlRUVjEwMTMyOTMud2VicA==",
      category: "Bollywood",
      description:
        "The series was initially intended as a limited series to be told in two parts. It had its original run of 15 episodes on Spanish network Antena 3 from 2 May 2017 through 23 November 2017. Netflix acquired global streaming rights in late 2017. It re-cut the series into 22 shorter episodes and released them worldwide, beginning with the first part on 20 December 2017, followed by the second part on 6 April 2018. In April 2018, Netflix renewed the series with a significantly increased budget for 16 new episodes total. Part 3, with eight episodes, was released on 19 July 2019. Part 4, also with eight episodes, was released on 3 April 2020",
    },
    {
      id: 13,
      title: "Land of Buddha :- Bodhgaya",
      img: "https://www.dhammawiki.com/images/thumb/4/4a/Mbt1.png/300px-Mbt1.png",
      category: "Bihar",
      description: "This is international place here people come from japan , Bhutan,Nepal and other contry also but here any electronics product is not allowed like mobile phone,bluethoth etc The Mahabodhi Temple Complex is one of the four holy sites related to the life of the Lord Buddha, and particularly to the attainment of Enlightenment. The first temple was built by Emperor Asoka in the 3rd century B.C., and the present temple dates from the 5th or 6th centuries. It is one of the earliest Buddhist temples built entirely in brick, still standing in India, from the late Gupta period.",
    },
    {
      id: 14,
      title: "80 Fits Buddha Temple",
      img: "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/12/shutterstock_402120757-1.webp",
      category: "Bihar",
      description: "This is international place here people come from japan , Bhutan,Nepal and other contry also ,The 80ft Buddha statue is one of the many stops in the Buddhist pilgrimage and tourist routes in Bodh Gaya, Bihar (India). The great statue is a mix of sandstone blocks and red granite. It is possibly the largest built in India and was consecrated on 18 November 1989 by the 14th Dalai Lama. The foundation stone for the statue was placed in 1982.",
    }, {
      id: 15,
      title: "Land Of Bishnupadh :- पितृपक्ष मेला",
      img: "https://www.pujasthan.com/wp-content/uploads/2023/01/Vishnupad-Temple-Gaya.jpg.webp",
      category: "Bihar",
      description: "This Mela known as Pithrupachh mela here people come from all state in india , why: -17 दिन चलता है पितृपक्ष मेला अश्विन मास के कृष्ण पक्ष को पितृपक्ष या महालय पक्ष कहा जाता है, जिसमें लोग अपने पुरखों का पिंडदान करते हैं. मान्यता है कि पिंडदान करने से मृत आत्मा को मोक्ष की प्राप्ति हो जाती है. ऐसे तो पिंडदान के लिए कई धार्मिक स्थान हैं परंतु सबसे उपयुक्त स्थल बिहार के गया को माना जाता है.  ",
    }, {
      id: 16,
      title: "Biggest water park in Bihar",
      img: "https://i.ytimg.com/vi/_qn7XsJf0As/maxresdefault.jpg",
      category: "Bihar",
      description: "#waterpark , Note- This Video is the not a Paid Promotion, Song Credit- Bappi Lahiri, Address- Chhama Chham- The water park, Nima Gaon, Near Sambodhi Resort, Bodhgaya, Bihar, India - 823001,",
    }, {
      id: 17,
      title: "काली मंदिर, मलयपुर, जमुई",
      img: "https://i0.wp.com/angdesh.com/wp-content/uploads/2022/07/Kali-Mandir-Malaypur-Jamui.jpg?w=686&ssl=1",
      category: "Bihar",
      description: " साल 1986 से अशोक सिंह के पहल पर मलयपुर में मां काली की पूजा शुरू की गई थी। इसके लिए ग्रामीणों ने यथाशक्ति सहयोग भी दिया। कहते है उस समय रात दिन एक जैसी भीड़ रहती थी। लाखो की संख्या में कई जिले से श्रद्धालु जुटते थे",
    }, {
      id: 18,
      title: "Goal Ghar patna",
      img: "https://yometro.com/images/places/golghar.jpg",
      category: "Bihar",
      description: "Golghar is one of the most famous landmarks of Patna, it is a huge granary which displays the Stupa style of architecture. This granary was built by Captain John Garstin in 1786. The winding stairs around the monument offer a spectacular view of the city and the Ganges flowing around it. Golghar looks like a huge hive when viewed from a distance. This old monument is a must see for anyone visiting Patna. It is one of the most important and historical monuments present in the city.",
    }, {
      id: 19,
      title: "Gola ghatara Lake",
      img: "https://lh5.googleusercontent.com/p/AF1QipMotSnHff6fDqvxnTq6Mcs-OCV2sj6BMA6SZfgu=w548-h318-n-k-no",
      category: "Bihar",
      description: "Rajgir is an ancient city in the northeast Indian state of Bihar. Surrounded by hills, it's known for its holy sites. Remains of the Cyclopean Wall, which encircled the city centuries ago, still stand in the center. Close by, Venu Vana park was once home to a monastery built for Buddha. The shield-shaped Japanese Temple contains a huge Buddha statue. Nearby there are hot springs believed to have medicinal properties",
    }, {
      id: 20,
      title: "Shanti Stupa at Rajgir",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/Shanti_Stupa_at_Rajgir_%28cropped%29.jpg/1280px-Shanti_Stupa_at_Rajgir_%28cropped%29.jpg",
      category: "Bihar",
      description: "Rajgir, meaning The City of Kings, is a historic town in the district of Nalanda in Bihar, India. As the ancient seat and capital of the Haryanka dynasty, the Pradyota dynasty, the Brihadratha dynasty and the Mauryan Empire, as well as the dwelling ground of such historical figures as The Buddha and The Mahavira, the city holds a place of prominence in Hindu, Buddhist and Jain scriptures. As of 2011, the population of the town was reported to be 41,000 while the population in the community development block was about 88,500.",
    },
    {
      id: 21,
      title: "Rajgir glass bridge",
      img: "https://www.livehindustan.com/web-stories/rajgir-glass-bridge-in-bihar-know-here-details-about-ticket-price-_NGQF5OgMnC5ZTH4sCCx/assets/5.jpeg",
      category: "Bihar",
      description: "Rajgir Glass Bridge, located in Bihar state, has now become a tourist attraction. The height of the bridge is 250 ft. Surrounded by five hills, the place is loved by people who love adventures. The bridge is made mostly the same as China’s Hangzhou Glass Bridge. At a time, almost 40 people can visit the bridge. The bridge welcomes people from all over the world.",
    }, {
      id: 22,
      title: "Rajgir Zoo Safari",
      img: "https://bindassbihari.com/wp-content/uploads/2022/02/onroad007-20220218-0001.webp",
      category: "Bihar",
      description: "Rajgir Zoo Safari :- लंबे समय के बाद अब Zoo Safari लोगो के लिए खोल दिया गया हैं, अब राजगीर में अन्य जगहों पर घूमने के साथ साथ लोग नेचर सफारी का भी आनंद उठा सकेंगे । बिहार के मुख्यमंत्री नीतीश कुमार ने राज्य वासियों को बुधवार को एक बड़ी सौगात दी है, सीएम ने नालंदा जिला के राजगीर में बने जू सफारी का उद्घाटन किया,जिसके बाद इसे आम लोगों के लिए खोल दिया हैं,होली के पहले ये सरकार के द्वारा ये तोहफा पाकर लोग काफी खुश हैं।",
    },
    {
      id: 23,
      title: "Litti Chokha",
      img: "https://static.toiimg.com/thumb/53188495.cms?imgsize=138903&width=509&height=340",
      category: "Food",
      description: "Bihari Favorites Food:- Looking for an authentic Litti Chokha recipe? Try this easy Litti Chokha recipe & enjoy",
    }, {
      id: 24,
      title: "Chiken Biryani",
      img: "https://www.cookwithnabeela.com/wp-content/uploads/2022/10/18.ChickenBiryani2.jpg",
      category: "Food",
      description: "I know there are SO many chicken biryani recipes out there and you are probably getting tired of looking for one recipe that you can stick to.However, look no further you have found THE chicken biryani recipe of the century. The fragrant aromas, the vibrant colours, and the fluffy rice are all bound together by the zing of heat and spices. What more could you ever want?!",
    }, {
      id: 25,
      title: "Eggs Roll",
      img: "https://s3-ap-south-1.amazonaws.com/betterbutterbucket-silver/moumita-malla20160228191932265.jpeg",
      category: "Food",
      description: "Take all purpose flour with a little bit salt in a bowl and mix properly. Add 1 tablespoon oil to the flour and make a soft dough using little water Cover the dough with a wet cloth and leave it for 15 minutes. Now take the dough and knead it for 1 minute and then divide it into 2 equal sized balls. Take one ball and roll it out into a circle of 6 inch diameter. In a bowl take one egg and sprinkle a little salt and beat it.",
    }, {
      id: 26,
      title: "Chiken Chaval",
      img: "https://pbs.twimg.com/media/DqXFq04XgAECVy6.jpg",
      category: "Food",
      description: "Chicken Pulao adds life to every occasion or party. This traditional dish needs no introduction and is a delightful blend of spiced chicken, rice and aromatic herbs. There are several ways of preparing this dish and we have the simplest recipe to prepare this dish. Here’s how you go about preparing it at home with some easily available ingredients. Wash and peel the veggies, take a mortar-pestle and add garlic and ginger. Crush them coarsely into a paste. Now, take chicken and cut it into pieces.",
    }, {
      id: 27,
      title: "Manchurian",
      img: "https://hebbarskitchen.com/wp-content/uploads/2022/11/Cabbage-Manchurian-Recipe-Dry-Patta-Veg-Gobi-Manchurian-Dry-Cabbage-Veg-Manchurian-Recipe-2-768x1152.jpeg.webp",
      category: "Food",
      description: "Cabbage Manchurian Recipe | Dry Patta Veg Gobi Manchurian | Dry Cabbage Veg Manchurian Recipe with detailed photo and video recipe. Yet another Indo-Chinese Cuisine or street food Manchurian recipe prepared with grated cabbage and Manchurian sauce. A crispy and popular Indian street food recipe comes in both gravy and dry versions and is often served with fried rice recipe. This style of manchuria is the best alternative to the popular gobi or paneer manchurian with an economical twist.",
    }, {
      id: 28,
      title: "Paneer Pulao",
      img: "https://r2.community.samsung.com/t5/image/serverpage/image-id/2170990iCDC5D9696CF1B635/image-size/large?v=v2&px=999",
      category: "Food",
      description: "Paneer Pulao Recipe in Hindi http://goo.gl/49cPFc Also known as paneer biryani recipe, paneer pulao recipe in hindi, Cottage Cheese Pulao",
    }, {
      id: 29,
      title: " Latest Hacking Computer",
      img: "https://sectigostore.com/blog/wp-content/uploads/2020/12/hacker-motivation-nation-state-actors-1024x640.jpg",
      category: "Tech",
      description: "Hacking is a highly risky game. Most countries have robust security laws and cybersecurity departments working hand-in-hand with local law enforcement officials to catch cybercriminals. To be a successful hacker, apart from having expertise in technology, people also need to know how to monetize their hacking skills without getting caught. You also need to have a strong hacker motivation.",
    }, {
      id: 30,
      title: "Super Computer",
      img: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgh8dSVcsR53jglNxcEnwoZ7escCAKtymuZiPlafOcq0L0UM5UOBx884pB7oxCmgfm9iBxsWT7LqL-bpjS8si1kZUbNdFL0wTgXz3DOjTBsH0EkOpPSxVmvfT3BX-VM0NZhP-Gb6R6C27fkIIqM2ZBy-RwyjUTl6psx1QfU-QF2iRbAI3d1bavhCDovjw/s959/How%20Businesses%20Can%20Benefit%20with%20Data%20Center%20India%20-%2014884%20_%20MyTechLogy.jpg",
      category: "Tech",
      description: "वर्तमान समय Computer का समय है| आजकल छोटे-छोटे कामों से लेकर बड़े-बड़े कामों में  computer का इस्तेमाल किया जाता हैं ऐसे मे हम सभी computer से परिचित है| अक्सर आपने भी Supercomputer के बारे में सुना होगा | कंप्युटर का उपयोग हम अपने कामों को आसान बनाने के लिए करते है परंतु यह Supercomputer क्या होता है? और इस Computer को किस काम के लिए बनाया गया है आज इस आटिकल के माध्यम से हम आपको बताने वाले है और साथ ही दुनिया के Top 10 Supercomputer के बारे मे भी जानने वाले है |  ( Top 10 Supercomputer in the World in Hindi ) और साथ ही इस कंप्युटर किस देश मे और किस कामों के लिए बनाया गया है यह भी जानने वाले है |",
    }, {
      id: 31,
      title: "Foldable Phone",
      img: "https://images1.livehindustan.com/uploadimage/library/2021/12/15/16_9/16_9_1/twitter_nextrift_1639562913.jpg",
      category: "Tech",
      description: "The Samsung Galaxy Fold series has gone unchallenged in India for the past few years, and we recently saw Samsung really stepping up its game with the Galaxy Z Fold 3 (Review). However, Oppo has just revealed one big surprise before we wrap up 2021, which gives us enough reason to rethink whether the Galaxy Z Fold indeed represents the best way to make a large-screen foldable. The Oppo Find N was unveiled a week ago as the company's first commercially available foldable smartphone, and even though it is on sale only in China, Oppo India sent us a unit to play with for a short while.",
    }, {
      id: 32,
      title: "Chandryan 3",
      img: "https://akm-img-a-in.tosshub.com/indiatoday/styles/medium_crop_simple/public/2023-07/chandrayaan_3_b.jpg?VersionId=KMvLAnlt_Dz2TqDevdxD3p7UlsEUmveF",
      category: "Tech",
      description: "By India Today Science Desk: Chandrayaan-3 has commenced its journey to the launchpad, encapsulated aboard the Launch Vehicle Mark-3 (LVM-3) at the Satish Dhawan Space Centre in Sriharikota.",
    }, {
      id: 33,
      title: "लड़ाकू विमान",
      img: "https://images.bhaskarassets.com/webp/thumb/512x0/web2images/521/2019/11/21/0521_rafale_2_2.jpg",
      category: "Tech",
      description: "ई दिल्ली. फ्रांस ने भारत को 3 राफेल जेट उपलब्ध करा दिए हैं। ये अभी फ्रांस में ही हैं और इनका इस्तेमाल भारतीय वायुसेना के पायलटों और टेक्नीशियंस के प्रशिक्षण में किया जा रहा है। यह जानकारी रक्षा राज्य मंत्री श्रीपाद नाइक ने लोकसभा में बुधवार को दी। इससे पहले रक्षा मंत्री राजनाथ सिंह ने 8 अक्टूबर को फ्रांस स्थित एयरबेस पर पहला राफेल जेट हासिल किया था। हालांकि, बाकी दो विमान कब सौंपे गए यह नहीं बताया गया",
    }, {
      id: 34,
      title: "Indian Ship",
      img: "https://static.abplive.com/wp-content/uploads/2020/08/31131924/indian-navy.jpg",
      category: "Tech",
      description: "New Delhi: Almost two and a half months after the Galwan Valley clash which led to death of as many as 20 Indian soldiers in eastern Ladakh, the Indian Navy has recently sailed one of its frontline warship to the South China sea. As per reports, the move by Indian Navy came as a displeasure to the Chinese side who raised objection over the development during the talks between two nations",
    },

    {
      id: 35,
      title: "The Money Heist",
      img: "",
      category: "Hollywwood",
      description: "",
    }, {
      id: 36,
      title: "The Money Heist",
      img: "",
      category: "Hollywwood",
      description: "",
    }, {
      id: 37,
      title: "The Money Heist",
      img: "",
      category: "Hollywwood",
      description: "",
    }, {
      id: 38,
      title: "The Money Heist",
      img: "",
      category: "Hollwywood",
      description: "",
    }, {
      id: 39,
      title: "The Money Heist",
      img: "",
      category: "Hollywwood",
      description: "",
    }, {
      id: 40,
      title: "The Money Heist",
      img: "",
      category: "Hollywwood",
      description: "",
    },

  ]);
  return (
    <div>
      <Store.Provider value={[details, setDetails]}>
        {props.children}
      </Store.Provider>
    </div>
  );
};

export default Details;
